/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationMiniSchema
 */
export interface OrganizationMiniSchema {
    /**
     * 
     * @type {string}
     * @memberof OrganizationMiniSchema
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationMiniSchema
     */
    id: number;
}

/**
 * Check if a given object implements the OrganizationMiniSchema interface.
 */
export function instanceOfOrganizationMiniSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function OrganizationMiniSchemaFromJSON(json: any): OrganizationMiniSchema {
    return OrganizationMiniSchemaFromJSONTyped(json, false);
}

export function OrganizationMiniSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationMiniSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'id': json['id'],
    };
}

export function OrganizationMiniSchemaToJSON(value?: OrganizationMiniSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
    };
}

